import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import useAppName from '../../hooks/useAppName';

const LogoCometeLink = ({ sx }) => {
  const appName = useAppName();
  return (
    <Box id="logo-comete-link" sx={{ minWidth: 24, minHeight: 24, ...sx }} alt={`Logo ${appName}`}>
      <svg
        id="Calque_1"
        xmlns="http://www.w3.org/2000/svg"
        x={0}
        y={0}
        width="100%"
        height="100%"
        viewBox="0 0 1400 507"
        style={{
          enableBackground: 'new 0 0 1400 507'
        }}
        xmlSpace="preserve"
      >
        <style>{'.st0{fill:#22427c}.st3{fill:#677179}'}</style>
        <path
          className="st0"
          d="M104.3 310.4c-29.9 0-54.8-10-74.6-30C9.9 260.4 0 235.7 0 206c0-29.6 9.9-54.4 29.8-74.4 19.8-20 44.7-30 74.6-30 19.6 0 37.2 4.7 52.8 14.1 15.6 9.4 27.2 22 34.9 37.9l-29 16.7c-5-10.6-12.8-19-23.2-25.4-10.5-6.3-22.3-9.5-35.5-9.5-19.8 0-36.4 6.7-49.8 20.2-13.4 13.5-20 30.3-20 50.4 0 19.8 6.7 36.5 20 50 13.4 13.5 30 20.2 49.8 20.2 13.2 0 25.1-3.1 35.7-9.3 10.6-6.2 18.6-14.6 24.2-25.2l29.4 17.1c-8.5 15.6-20.6 28.1-36.5 37.5-16 9.4-33.6 14.1-52.9 14.1zM873.3 221.9c3.4 17.7 11.6 31.5 24.4 41.3 12.8 9.8 28.6 14.7 47.4 14.7 26.2 0 45.2-9.7 57.1-29l29.4 16.7c-19.3 29.9-48.4 44.8-87.3 44.8-31.5 0-57.1-9.9-76.8-29.6-19.6-19.7-29.5-44.6-29.5-74.8 0-29.9 9.6-54.8 29-74.6 19.3-19.8 44.3-29.8 75-29.8 29.1 0 52.8 10.3 71.2 30.7 18.4 20.5 27.6 45.2 27.6 74 0 5-.4 10.2-1.2 15.5H873.3zm68.7-87.7c-18.5 0-33.9 5.2-46 15.7-12.2 10.5-19.7 24.4-22.6 41.9h132.5c-2.9-18.8-10.3-33.1-22.2-42.8-12-9.9-25.9-14.8-41.7-14.8zm24.2-54.7h-33.3l-40.1-52.4h41.7l31.7 52.4zM1179.8 140.2H1127v107.5c0 9.8 1.9 16.7 5.8 20.8 3.8 4.1 9.7 6.2 17.7 6.3 7.9.1 17.7-.1 29.4-.6v30.9c-30.2 4-52.2 1.5-66.3-7.3-14-8.9-21-25.6-21-50.2V140.2h-39.3v-33.3h39.3V61.6l34.5-10.3v55.5h52.8v33.4zM1232.6 221.9c3.4 17.7 11.6 31.5 24.4 41.3 12.8 9.8 28.6 14.7 47.4 14.7 26.2 0 45.2-9.7 57.1-29l29.4 16.7c-19.3 29.9-48.4 44.8-87.3 44.8-31.5 0-57.1-9.9-76.8-29.6-19.7-19.7-29.6-44.6-29.6-74.8 0-29.9 9.6-54.8 29-74.6 19.3-19.8 44.3-29.8 75-29.8 29.1 0 52.8 10.3 71.2 30.7 18.4 20.5 27.6 45.2 27.6 74 0 5-.4 10.2-1.2 15.5h-166.2zm68.6-87.7c-18.5 0-33.9 5.2-46 15.7-12.2 10.5-19.7 24.4-22.6 41.9h132.5c-2.9-18.8-10.3-33.1-22.2-42.8-11.9-9.9-25.8-14.8-41.7-14.8zM769.5 305.2V183.3c0-25.6-20.8-46.4-46.4-46.4-25.5 0-46.3 20.7-46.4 46.2v122.1h-34.4V183.1c-.1-25.5-20.9-46.2-46.4-46.2-25.6 0-46.4 20.8-46.4 46.4v121.9h-34.3l-.1-125c0-44.6 36.3-80.8 80.8-80.8 22.8 0 44.7 9.8 60 26.9l3.6 4 3.6-4c15.3-17.1 37.2-26.9 60-26.9 44.6 0 80.8 36.3 80.8 80.8v125h-34.4zM168.4.3l106.8 243.3c17.2 39.2 55.8 64.4 98.3 64.4h1.7c59.3-.9 106.7-50 105.8-109.5-.7-43.3-27.1-82.1-67.1-98.3L168.4.3z"
        />
        <radialGradient id="SVGID_1_" cx={282.64} cy={111.925} r={283.127} gradientUnits="userSpaceOnUse">
          <stop
            offset={0}
            style={{
              stopColor: '#ffec00'
            }}
          />
          <stop
            offset={0.131}
            style={{
              stopColor: '#fee400'
            }}
          />
          <stop
            offset={0.736}
            style={{
              stopColor: '#f8bf00'
            }}
          />
        </radialGradient>
        <path
          d="M375.1 300c32-.5 60.2-16.1 78.1-40-5.9-14.7-20.2-25.1-37-25.1h-71.3c-21.2 0-38.6 16.7-39.8 37.7 18.2 17.3 42.5 27.5 68.5 27.5.4-.1 1-.1 1.5-.1z"
          style={{
            fill: 'url(#SVGID_1_)'
          }}
        />
        <radialGradient
          id="SVGID_00000125587696784748088160000008596569416033314706_"
          cx={282.64}
          cy={111.925}
          r={283.127}
          gradientUnits="userSpaceOnUse"
        >
          <stop
            offset={0}
            style={{
              stopColor: '#ffec00'
            }}
          />
          <stop
            offset={0.131}
            style={{
              stopColor: '#fee400'
            }}
          />
          <stop
            offset={0.736}
            style={{
              stopColor: '#f8bf00'
            }}
          />
        </radialGradient>
        <path
          style={{
            fill: 'url(#SVGID_00000125587696784748088160000008596569416033314706_)'
          }}
          d="M380.5 218.1c23.2 0 41.9-18.8 41.9-41.9 0-23.2-18.8-41.9-41.9-41.9-23.2 0-41.9 18.8-41.9 41.9-.1 23.1 18.7 41.9 41.9 41.9z"
        />
        <path
          className="st3"
          d="M1145.1 383.1c-3.5 0-6.4-1.2-8.8-3.5-2.4-2.4-3.6-5.2-3.6-8.5s1.2-6.2 3.6-8.6c2.4-2.4 5.3-3.6 8.8-3.6 3.4 0 6.2 1.2 8.6 3.6 2.4 2.4 3.6 5.3 3.6 8.6s-1.2 6.2-3.6 8.5c-2.3 2.3-5.2 3.5-8.6 3.5zm-9.2 123.1V402h18.2v104.1h-18.2zM1234.2 399.3c12.3 0 22.1 3.9 29.5 11.6 7.4 7.7 11.1 18.2 11.1 31.3v63.9h-18.2v-62.9c0-8.5-2.3-15-6.9-19.7-4.6-4.7-11-7-19.1-7-9.1 0-16.4 2.8-22 8.4-5.6 5.6-8.4 14.3-8.4 25.9V506H1182V402h18.2v15c7.5-11.8 18.8-17.7 34-17.7zM1388.9 506.2h-22.6l-47.8-49.3v49.3h-18.2V360.4h18.2v87.5l45.3-45.9h23.5l-50.1 50.4 51.7 53.8zM1113 490.3h-5.2c-4.2-.1-7.3-1.2-9.3-3.3-2-2.2-3-5.8-3-10.9V358.7h-18.2V476c0 12.9 3.7 21.7 11.1 26.3 5.7 3.6 13.9 5.2 24.7 4.7v-16.7z"
        />
      </svg>
    </Box>
  );
};
LogoCometeLink.propTypes = {
  sx: PropTypes.object
};

export default LogoCometeLink;
